"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIGIT_SECTION_DELIMITER = exports.DIGIT_FORMATTER_REGEX = exports.FRACTION_DELIMITER = void 0;
exports.FRACTION_DELIMITER = ',';
exports.DIGIT_FORMATTER_REGEX = /\d(?=(\d{3})+(,|$))/g;
exports.DIGIT_SECTION_DELIMITER = '$& ';
